import { Container, Row } from "reactstrap";
import { BonusUi, Tour } from "../../../constants";
import UserProfileFifthStyle from "./UserProfileFifthStyle";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import UserProfileFirstStyle from "./userProfileFirstStyle";
import UserProfileSecondStyle from "./userProfileSecondStyle";
import UserProfileThirdStyle from "./userProfileThirdStyle";
import UserProfileFourthStyle from "./UserProfileFourthStyle";

const TourMain = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Tour} parent={BonusUi} />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <UserProfileFirstStyle />
            <UserProfileSecondStyle />
            <UserProfileThirdStyle />
            <UserProfileFourthStyle />
            <UserProfileFifthStyle />
          </Row>
        </div>
      </Container>
    </>
  );
};

export default TourMain;
